import React, {useEffect, useState} from 'react';
import {t} from "i18next";
import {Modal} from "../components/Modal";
import {addMedicalCondition} from "../service/accountApi";
import {ChevronDownIcon} from "@radix-ui/react-icons";
import {Transition} from "@headlessui/react";

export const AddMedicalConditionForm = (props) => {
    const {showAddMedicalConditionForm, setShowAddMedicalConditionForm, accountDetails, setAccountDetails} = props;

    const [medicalConditionNames, setMedicalConditionNames] = useState([
        {
            label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.DEFAULT"),
            value: "",
        },
        {
            label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.ALLERGIES"),
            value: "Allergies",
            icon: "/assets/allergies-icon-dark.svg"
        },
        {
            label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.ASTHMA"),
            value: "Asthma",
            icon: "/assets/asthma-icon-dark.svg"
        },
        {
            label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.BACK_PROBLEM"),
            value: "Back Problems",
            icon: "/assets/back-problems-icon-dark.svg"
        },
        {
            label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.NERVE_DAMAGE"),
            value: "Nerve Damage",
            icon: "/assets/nerve-damage-icon-dark.svg"
        },
        {
            label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.DIABETES"),
            value: "Diabetes",
            icon: "/assets/diabetes-icon-dark.svg"
        },
        {
            label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.CANCER"),
            value: "Cancer",
            icon: "/assets/cancer-icon-dark.svg"
        },
        {
            label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.BP"),
            value: "BP",
            icon: "/assets/bp-icon-dark.svg"
        },
        {
            label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.EPILEPSY"),
            value: "Epilepsy",
            icon: "/assets/epilepsy-icon-dark.svg"
        },
        {
            label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.OTHER"),
            value: "Other",
            icon: "/assets/medical-condition-default-icon-dark.svg"
        }
    ]);

    const [isMedicalConditionNameDropdownOpen, setIsMedicalConditionNameDropdownOpen] = useState(false);
    const [isSelectingMedicalConditionName, setIsSelectingMedicalConditionName] = useState(false);

    const [medicalConditionDetails, setMedicalConditionDetails] = useState({
        medicalConditionName: '',
        otherMedicalConditionName: '',
        medicalConditionDescription: '',
    });

    const [error, setError] = useState({});

    const [isAddMedicalConditionButtonDisabled, setIsAddMedicalConditionButtonDisabled] = useState(false);

    const medicalConditionNameLabel = (medicalConditionName) => {
        switch (medicalConditionName) {
            case 'Allergies':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.ALLERGIES"),
                    icon: "/assets/allergies-icon-dark.svg"
                };
            case 'Asthma':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.ASTHMA"),
                    icon: "/assets/asthma-icon-dark.svg"
                };
            case 'Back Problems':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.BACK_PROBLEM"),
                    icon: "/assets/back-problems-icon-dark.svg"
                };
            case 'Nerve Damage':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.NERVE_DAMAGE"),
                    icon: "/assets/nerve-damage-icon-dark.svg"
                };
            case 'Diabetes':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.DIABETES"),
                    icon: "/assets/diabetes-icon-dark.svg"
                };
            case 'Cancer':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.CANCER"),
                    icon: "/assets/cancer-icon-dark.svg"
                };
            case 'BP':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.BP"),
                    icon: "/assets/bp-icon-dark.svg"
                };
            case 'Epilepsy':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.EPILEPSY"),
                    icon: "/assets/epilepsy-icon-dark.svg"
                };
            case 'Other':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.OTHER"),
                    icon: "/assets/medical-condition-default-icon-dark.svg"
                };
            default:
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.DEFAULT")
                };
        }
    }

    const handleMedicalConditionNameSelect = (medicalConditionName) => {
        setIsSelectingMedicalConditionName(false);
        setIsMedicalConditionNameDropdownOpen(false);

        if (medicalConditionName !== medicalConditionDetails.medicalConditionName) {
            setMedicalConditionDetails({
                ...medicalConditionDetails,
                medicalConditionName: medicalConditionName,
                otherMedicalConditionName: ''
            })
        }
    }

    const handleFormData = (e) => {
        console.log(e.target.name + ': ' + e.target.value);

        setMedicalConditionDetails({
            ...medicalConditionDetails,
            [e.target.name]: e.target.value
        });

        setError({
            ...error,
            [e.target.name]: ""
        });
    }

    const validate = () => {
        let err = {};

        if (medicalConditionDetails.medicalConditionName === '') {
            err['medicalConditionName'] = t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.REQUIRED_ERROR");
        }

        return err;
    }

    const handleSubmit = async () => {
        console.log("Inside Handle Submit!");

        setIsAddMedicalConditionButtonDisabled(true);
        const err = validate();

        if (Object.keys(err).length > 0) {
            setError(err);
            setIsAddMedicalConditionButtonDisabled(false);
            return;
        }

        console.log("Medical Condition Details: ", medicalConditionDetails);

        const medicalConditionData = {
            userAccountId: accountDetails._id,
            medicalConditionDetails: medicalConditionDetails,
        };
        const addMedicalConditionDataResponse = await addMedicalCondition(medicalConditionData);

        console.log('(AddMedicalConditionForm) Add Medical Condition Data Response: ', addMedicalConditionDataResponse);

        if (addMedicalConditionDataResponse.success) {
            setAccountDetails(addMedicalConditionDataResponse.data);
            setShowAddMedicalConditionForm(false);
            setIsAddMedicalConditionButtonDisabled(false);
            setMedicalConditionDetails({
                medicalConditionName: '',
                medicalConditionDescription: '',
            });
        }
    }

    useEffect(() => {
        if (accountDetails && accountDetails.medicalConditionDetails?.length > 0) {
            const userMedicalConditionNames = accountDetails.medicalConditionDetails.map(condition => condition.medicalConditionName);

            const filteredMedicalConditionNames = medicalConditionNames.filter(condition =>
                condition.value === "" || condition.value === "Other" ||
                !userMedicalConditionNames.includes(condition.value)
            );

            setMedicalConditionNames(filteredMedicalConditionNames);
        }
    }, [accountDetails]);

    const handleClose = () => {
        setShowAddMedicalConditionForm(false);
        setTimeout(() => {
            setMedicalConditionDetails({
                medicalConditionName: '',
                medicalConditionDescription: '',
            });
        }, 200);
    }

    return (
        <Modal isOpen={showAddMedicalConditionForm}>
            <div className="form-modal-container">
                {/* Header */}
                <div className={"form-modal-header-container"}>
                    {/* Header Title | Close Button */}
                    <div className={"flex flex-row items-center justify-between"}>
                        {/* Form Title */}
                        <h2>
                            {t("MEDICAL_CONDITION_FORM.ADD_TITLE")}
                        </h2>

                        <button onClick={handleClose}>
                            <img
                                className={"w-[75%] h-[75%]"}
                                src={"/assets/close-icon.png"}
                                alt={"Close"}
                                title={"Close"}
                            />
                        </button>
                    </div>

                    {/* Divider */}
                    <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
                </div>

                {/* Form Fields */}
                <div className={"form-modal-body-container"}>
                    {/* Medical Condition Name */}
                    <div className={`custom-input-container`}>
                        <label>
                            {t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.LABEL")}
                        </label>
                        <div className="w-full flex flex-col">
                            <button
                                onBlur={() => {
                                    if (!isSelectingMedicalConditionName) {
                                        setIsMedicalConditionNameDropdownOpen(false);
                                    }
                                }}
                                className="custom-input-dropdown-button"
                                onClick={() => setIsMedicalConditionNameDropdownOpen(!isMedicalConditionNameDropdownOpen)}
                            >
                                <div>
                                    {
                                        medicalConditionDetails.medicalConditionName !== "" && (
                                            <img
                                                src={medicalConditionNameLabel(medicalConditionDetails.medicalConditionName).icon}
                                                alt={medicalConditionNameLabel(medicalConditionDetails.medicalConditionName).label}
                                            />
                                        )
                                    }
                                    <p>
                                        {medicalConditionNameLabel(medicalConditionDetails.medicalConditionName).label}
                                    </p>
                                </div>
                                <ChevronDownIcon
                                    className={`${isMedicalConditionNameDropdownOpen ? 'rotate-180' : 'rotate-0'} `}
                                    aria-hidden="true"
                                    stroke="#292D32"
                                    strokeWidth={"0.1vh"}
                                />
                            </button>

                            {/* Medical Condition Name Dropdown */}
                            <div className={""}>
                                <Transition show={isMedicalConditionNameDropdownOpen}>
                                    <div
                                        className={`bg-white absolute left-0 right-0 z-[100]
                                            origin-top-right rounded-md shadow-2xl mt-[0.5vh]
                                            portrait:mx-[1.25rem] portrait:jk:mx-[1.75rem] portrait:lg:mx-[2.25rem]
                                            landscape:mx-[0.75rem] landscape:jk:mx-[0.9rem] landscape:lg:mx-[1.15rem]
                                            border border-gray-700
                                            data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 
                                            data-[enter]:duration-100 data-[enter]:ease-out 
                                            data-[leave]:duration-75 data-[leave]:ease-in`}
                                    >
                                        <div className={"w-full flex-1 overflow-hidden relative rounded-md"}>
                                            <div
                                                className="flex-1 flex flex-col max-h-[20vh] w-full overflow-y-scroll"
                                            >
                                                {
                                                    medicalConditionNames.map((medicalConditionName, index) => (
                                                        <button
                                                            key={index}
                                                            className="custom-input-dropdown-list-button"
                                                            onMouseDown={() => setIsSelectingMedicalConditionName(true)}
                                                            onClick={() => handleMedicalConditionNameSelect(medicalConditionName.value)}
                                                        >
                                                            {
                                                                medicalConditionName.value !== "" && (
                                                                    <img
                                                                        src={medicalConditionName.icon}
                                                                        alt={medicalConditionName.label}
                                                                    />
                                                                )
                                                            }
                                                            <p>
                                                                {medicalConditionName.label}
                                                            </p>
                                                        </button>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </Transition>
                            </div>

                            {
                                error['medicalConditionName'] &&
                                <p className="text-[0.75vw] text-red-600 font-custom-regular" id="error">
                                    {error['medicalConditionName']}
                                </p>
                            }
                        </div>
                    </div>

                    {/* Medical Condition Description */}
                    {
                        medicalConditionDetails.medicalConditionName === 'Other' && (
                            <div className={`custom-input-container`}>
                                <label htmlFor="otherMedicalConditionName">
                                    {t("MEDICAL_CONDITION_FORM.OTHER_MEDICAL_CONDITION_NAME.LABEL")}
                                </label>

                                <div className="flex-1 flex flex-col">
                                    <input
                                        type={"text"}
                                        id="otherMedicalConditionName"
                                        className="custom-input"
                                        name='otherMedicalConditionName'
                                        value={medicalConditionDetails.otherMedicalConditionName}
                                        onChange={handleFormData}
                                    />
                                </div>
                            </div>
                        )
                    }

                    {/* Medical Condition Description */}
                    <div className={`custom-input-container`}>
                        <label htmlFor="medicalConditionName">
                            {t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_DESCRIPTION.LABEL")}
                        </label>

                        <div className="flex-1 flex flex-col">
                            <textarea
                                id="medicalConditionDescription"
                                className="custom-input"
                                name='medicalConditionDescription'
                                value={medicalConditionDetails.medicalConditionDescription}
                                onChange={handleFormData}
                            />
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className={"form-modal-footer-container"}>
                    {/* Divider */}
                    <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

                    {/* Submit Button Container */}
                    <div className="flex items-center justify-end">
                        {/* Submit Button */}
                        <button
                            disabled={isAddMedicalConditionButtonDisabled}
                            onClick={handleSubmit}
                            className="form-modal-footer-container-submit-button"
                        >
                            <p>
                                {t("MEDICAL_CONDITION_FORM.ADD_SUBMIT")}
                            </p>
                            <svg
                                viewBox="0 0 6 6"
                                fill="none"
                                id={"arrow-icon"}
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M3 1L5 3L3 5"
                                    id={"arrow-icon-tip"}
                                    stroke="black"
                                    strokeLinecap="square"
                                />
                                <path
                                    d="M1 3L4 3"
                                    id={"arrow-icon-line"}
                                    stroke="black"
                                    strokeLinecap="square"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
